import {Component, Input, OnInit} from '@angular/core';

@Component({
  selector: 'app-player-stats-table-of-details',
  templateUrl: './player-stats-table-of-details.component.html',
  styleUrls: ['./player-stats-table-of-details.component.scss']
})
export class PlayerStatsTableOfDetailsComponent implements OnInit {

  @Input() tableContent;

  constructor() { }

  ngOnInit(): void {
  }


  getTournamentName(tournamentRecord) {
    return tournamentRecord?.name;
  }

  getTournamentId(tournamentRecord) {
    return tournamentRecord?.id;
  }

  getTournamentStartAt(tournamentRecord) {
    return tournamentRecord?.start_at;
  }

  getTournamentPlace(tournamentRecord) {
    return tournamentRecord?.place;
  }

  getTournamentStartDate(tournamentRecord) {
    return new Date(this.getTournamentStartAt(tournamentRecord)).toLocaleDateString()
  }

  twoDigitNumber(num: number) {
    return num <= 9 ? '0' + num : '' + num;
  }

  getTournamentStartHourAndMinutes(tournamentRecord) {
    const dateObject = new Date(this.getTournamentStartAt(tournamentRecord));
    return `${this.twoDigitNumber(dateObject.getHours())}:${this.twoDigitNumber(dateObject.getMinutes())}`;
  }

}
